module.exports = new __parcel__URL__("download-animation.dafd6881.gif").toString();